import React from "react";
import { Link } from "react-router-dom";


const UserRoleField = ({
    role,
    linked = true,
    className = "",
    emptyValue = "",
}) => {

    if (!linked)
    {
        return (
            <span
                className={ className }
                style={ { color: role?.colorHex } }
                title={ role?.label || undefined }>
                { role?.label || emptyValue }
            </span>
        );
    }

    return (
        <Link
            className="table-link-underline"
            style={ { textTransform: 'uppercase', color: role?.colorHex } }
            to={ `/user-groups/${ role?.id }` }>
            <strong>{ role?.label }</strong>
        </Link>
    );
};

export default UserRoleField;


